import script from "./AddMember.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMember.vue?vue&type=script&setup=true&lang=js"

import "./AddMember.vue?vue&type=style&index=0&id=2c4e9b10&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c4e9b10"]])

export default __exports__